// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wy8C","left":"styles_left__-uYco"};